const RELIGION = [
    { value: "Catholic", label: "Católica" },
    { value: "Evangelical", label: "Evangélica" },
    { value: "Spiritist", label: "Espírita" },
    { value: "Atheist", label: "Ateia" },
    { value: "Other", label: "Outra" },
    { value: "NotDeclared", label: "Não Declarada" },
];
export default RELIGION;